module.exports = __webpack_public_path__ + "media/background.d5bb2c14.mp3";